/**
 * The admin module ID in the new backend.
 * Modules column stores a comma-separated list: "1,2,3"
 *   1 = admin, 2 = client, 3 = supplier
 */
export const ADMIN_MODULE_ID = "1";

/**
 * Returns true when the user's module list includes the admin module.
 * Accepts a comma-separated string (from User.modules) or a pre-resolved role tag.
 */
export function isAdminAllowedRole(modulesOrRole?: string | null): boolean {
    if (!modulesOrRole) {
        return false;
    }

    // Support the normalised "Admin" tag set during login mapping
    if (modulesOrRole === "Admin") {
        return true;
    }

    // Support raw comma-separated modules from the backend
    const parts = modulesOrRole.split(",").map((s) => s.trim());
    return parts.includes(ADMIN_MODULE_ID);
}
